(function($) {

	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		var swiper = new Swiper('.swiper-container', {
				slidesPerView: 1,
				spaceBetween: 0,
				slidesOffsetBefore: 0,
				grabCursor: true,
				keyboardControl: true,
				nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
				loop: true,
				pagination: false,
        paginationClickable: true,
				paginationType: 'fraction',
				autoplay: 5000,
				speed: 600,
        autoplayDisableOnInteraction: true,
        paginationBulletRender: function (swiper, index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
		});

	});

	/* Resize functions */
	$(window).resize(function() {

		// Get Window Width and Height
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

	});

})(jQuery);
